import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import '../../Assets/Styles/admin.css';
import React,{useState,useEffect} from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,useNavigate} from 'react-router-dom';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { addLocale } from 'primereact/api';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

import Box from '@mui/material/Box';

import moment from "moment";

// Load Icons
import iconVisa from '../../Assets/Images/creditcard/visa.svg';
import iconMastercard from '../../Assets/Images/creditcard/mastercard.svg';
import iconAmex from '../../Assets/Images/creditcard/amex.svg';
import iconDefaultCreditcard from '../../Assets/Images/creditcard/default.svg';
import iconElo from '../../Assets/Images/creditcard/elo.svg';
import iconHipercard from '../../Assets/Images/creditcard/hipercard.svg';
import iconDiscover from '../../Assets/Images/creditcard/discover.svg';
import iconDiners from '../../Assets/Images/creditcard/diners.svg';
import iconJcb from '../../Assets/Images/creditcard/jcb.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as PartnerActions from '../../Store/Actions/Partner';

import HeaderView from '../../Components/Layout/Header';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import AlertView from '../../Components/AlertModal';
import CreditCardModal from './CreditCardModal';

import StatusNotification from '../../Components/StatusNotification';


import {
	validarNomeCartao,
	validarNumeroCartao,
	validarValidadeCartao,
	maskCardNumber
} from '../../Components/Utils';

const ccFlag = {
  visa: iconVisa,
  mastercard: iconMastercard,
  amex: iconAmex,
  elo:iconElo,
  general: iconDefaultCreditcard,
  hipercard: iconHipercard,
  discover: iconDiscover,
  diners: iconDiners,
  jcb: iconJcb
};

// export default function Reservation() {
const CreditcardsView = (props) => {
	
// Set var from props
const {
	setDialog,
	dialog,
	createCompanyCreditcard,
	updateCompanyCreditcard,
	deleteCompanyCreditcard,
	retrieveCompanyCreditcards
} = props;

// Set Overlay obj
const toast = React.useRef(null);

const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

const [creditCards, setCreditCards] = useState([]);

const [showCardModal, setShowCardModal] = useState(false);
const [cardToEdit, setCardToEdit] = useState(null);
  
/* -------------------------------- */ 
/* Modal Methods START */
/* -------------------------------- */
const openCreateModal = () => {
  setCardToEdit(null);
  setShowCardModal(true);
};

const openEditModal = (card) => {
  setCardToEdit(card);
  setShowCardModal(true);
};

const handleCardSuccess = () => {
  retrieveItemsList(); // recarrega os cartões
};

const handleDeleteCard = (card) => {
  confirmDialog({
    message: `Tem certeza que deseja excluir o cartão "${card.label ? card.label : 'Sem nome do cartão'}"?`,
    header: 'Confirmação',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Sim, excluir',
    rejectLabel: 'Cancelar',
	acceptClassName: 'filledButton',
	rejectClassName: 'textButton',	
    accept: () => {
      deleteCompanyCreditcard(card.id, {
        setSuccess: () => {
		  showSuccessToast("Cartão excluído", "O cartão foi excluído com sucesso.");
          retrieveItemsList();
        },
        setError: (msg) => {
		  showErrorToast("Erro ao excluir cartão", msg);
        }
      });
    }
  });
};

const showSuccessToast = (summary, detail) => {
  toast.current?.show({
    severity: 'success',
    summary,
    detail,
    life: 3000
  });
};

const showErrorToast = (summary, detail) => {
  toast.current?.show({
    severity: 'error',
    summary,
    detail,
    life: 4000
  });
};
 

const retrieveItemsList = () => {
  
   const propsAction = {
    setSuccess: (cards) => {
		setLoading(false);
		setCreditCards(cards);	
	},
    setError: (msg) => {
      setAlertTitle("Erro ao buscar cartões");
      setAlertBody(msg);
      setAlert(true);
    }
  };
  retrieveCompanyCreditcards(propsAction);

}; // end retrieveItemsList	

/* -------------------------------- */ 
/* Modal Methods  END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Run after mount component
React.useEffect(() => {


  // set scroll to top
  window.scrollTo(0, 1);
  
  // set loading to true
  setLoading(true);
  retrieveItemsList(); // Retrieve credit cards from API
	  
  // Runs when UNMOUNT component
  return () => {
	
	// unmount...	
	
  };
  
}, []); // end useEffect 

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"40px",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "unset" : "64px",width:"100%",display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"center",gap:isMobile ? "1rem" : "",paddingBottom:isMobile ? "1rem" : ""}}>
							
								<div style={{textAlign:"left",flex:2,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Cartões de Crédito</div>
								
								<div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
									<Button label="Adicionar cartão" className="filledButton" icon="pi pi-plus" loading={saving} onClick={openCreateModal} style={{height:"unset"}} size="small" />
								</div>
							
							</div>
							
							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>
			
									<Box
									  sx={{
										width: isMobile ? "100%" : "80%",
										padding:"20px",
										minHeight:"50vh"
									  }}
									>
										<div className="registerModalIntro"> <i>Se desejar, você pode adicionar um ou mais cartões. <br />Você pode editar apenas o nome do cartão ou excluir o mesmo. Caso exclua todos os cartões e não deixe um cartão válido a sua conta ficará com pendência. <br /> Você só pode ter um cartão principal que será utilizado para cobranças.</i></div>

										<Divider />

										{loading &&
										<>
											<div className="flex-row justify-center align-items-center" style={{minHeight:"45vh",width:"100%",zIndex:"10",backgroundColor:"#FFF"}}>
												<div className="flex flex-column align-items-center">
													<ProgressSpinner style={{width:"50px",height:"50px"}} />
													<span style={{marginTop:"1rem",fontSize:"1.1rem",fontFamily:"Graphie"}}>Carregando cartões...</span>
												</div>
											</div>
										</>
										}										


										{!loading &&
										<>
											<Box style={{display:"flex",flexDirection:"row",alignItems:"flex-start",justifyContent:"flex-start",flexWrap:"wrap"}}>

											{/* Results from API */}
											{creditCards.map((item) => {

													return (
															<div className="ccCard" style={{margin:isMobile ? "" : "20px",maxWidth:"350px",minWidth:isMobile ? "100%" : ""}} key={item.id}>
															<div className="ccCard_header flex-row justify-start align-items-center gap-1" color="info" icon>
																<h4 className="ccCard_body__title">{item.label || 'Sem nome do cartão'}</h4>
																<div style={{textAlign:"right",flex:1,display:"flex",justifyContent:"flex-end"}}>
																	<Button
																	icon="pi pi-pen-to-square"
																	className="textButton"
																	onClick={() => openEditModal(item)}
																	style={{ alignSelf: "flex-end", height: "unset" }}
																	/>
																	<Button
																	icon="pi pi-times"
																	className="textButton"
																	onClick={() => handleDeleteCard(item)}
																	style={{ alignSelf: "flex-end", height: "unset" }}
																	/>
																</div>
															</div>
															<div className="ccCard_body flex-column justify-start align-items-center gap-1" style={{padding:"0.5rem"}}>	

																<div className="flex-1 flex-row justify-between align-items-center gap-1" style={{width:"100%",padding:"0.25rem",marginTop:"0.75rem"}}>
																	<div className="ccCard_body__reference" style={{fontSize:isMobile ? "1.2rem" : ""}}>{item.referenceNumber}</div>
																	<div className="ccCard_body__flag"> <img src={ccFlag[item?.cardFlag?.toLowerCase()] || ccFlag.general} alt="Bandeira do cartão" style={{ width: "auto", height: "2rem", marginBottom: isMobile ? "unset" : "" }} /></div>
																</div>

																<div className="flex-1 flex-row justify-between align-items-center gap-1" style={{width:"100%",padding:"0.25rem"}}>
																	<div className="ccCard_body__holderName" style={{fontSize:isMobile ? "1.2rem" : ""}}>{item.holderName}</div>
																	<div className="ccCard_body__expiration">{item.expirationDate}</div>
																</div>															

																<div className="flex-row justify-start align-items-center gap-1" style={{width:"100%",padding:"0.25rem"}}>
																	<div className="ccCard_body__mainCard flex-row justify-start align-items-center gap-1">
																		<i className={`pi pi-${item.mainCreditcard ? "check" : "times"}`} style={{color:item.mainCreditcard ? "green" : "#FF0000"}}></i>
																		<div>Cartão principal</div>
																	</div>
																</div>																	

															</div>

															</div>
														)}
												)}	

												{creditCards.length === 0 && 
												<>
													<StatusNotification status="error" summary="Pendência" message={<>Você não tem ao menos um <b>Cartão de crédito</b> cadastrado. Adicione ao menos um cartão de crédito para começar a receber direcionamentos.</>} />
													<div className="ccCard_noDocument" style={{padding:"2rem",fontSize:"2rem"}}> Nenhum cartão de crédito cadastrado... </div>						
												</>
												}										

											</Box>
										</>
										}																	  
										  
										{!loading &&
										<>
											<div className="modalFooterButtons" style={{marginTop:"20px",textAlign:"left"}}>
												<div className="modalFooterButtonsRight">
													<Button label="Adicionar cartão" className="filledButton" icon="pi pi-plus" loading={saving} onClick={openCreateModal} />
												</div>
											</div>
										</>
										}

									<CreditCardModal
									visible={showCardModal}
									onHide={() => setShowCardModal(false)}
									onSuccess={handleCardSuccess}
									cardToEdit={cardToEdit}
									createCompanyCreditcard={createCompanyCreditcard}
									updateCompanyCreditcard={updateCompanyCreditcard}
									setAlert={setAlert}
									setAlertTitle={setAlertTitle}
									setAlertBody={setAlertBody}
									showSuccessToast={showSuccessToast}
									showErrorToast={showErrorToast}
									retrieveItemsList={retrieveItemsList}
									/>																				
							
									<AlertView
										alert={alert}
										setAlert={setAlert}
										alertTitle={alertTitle}
										alertBody={alertBody}
										alertAction={alertAction}
										scrollBlock={true}				
									/>
									
								</Box>
								
									
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>
		
				
	</div>
	<ConfirmDialog />
	<Toast ref={toast} position="bottom-center" />
	</>
  );
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(CreditcardsView);	


